import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {__} from "~/ts/library/Translate";
import HelpIcon from "~/cabinet/vue/interface/form/HelpIcon.vue";
import HelpBlock from "~/cabinet/vue/interface/HelpBlock.vue";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "NonFreeConfigOption"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    block: { type: Boolean }
  },
  setup(__props: any) {

let props = __props;

let text = __("Эта настройка недоступна для бесплатного тарифа");


return (_ctx: any,_cache: any) => {
  return (__props.block)
    ? (_openBlock(), _createBlock(HelpBlock, { key: 0 }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(text)), 1)
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(HelpIcon, { key: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(text)), 1)
        ]),
        _: 1
      }))
}
}

})